import { render, staticRenderFns } from "./TwainImageViewer.vue?vue&type=template&id=2598bdc4&scoped=true&"
import script from "./TwainImageViewer.vue?vue&type=script&lang=js&"
export * from "./TwainImageViewer.vue?vue&type=script&lang=js&"
import style0 from "./TwainImageViewer.vue?vue&type=style&index=0&id=2598bdc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2598bdc4",
  null
  
)

export default component.exports